export default __webpack_public_path__ + "static/media/Icon ionic-ios-star.2400af12.svg";